import axios from "axios";
import { UserModel } from "../types/UserModel";

export type StartupMessage = {
    registrars: string[];
    user: UserModel;
    apiServices: [];
    scribensApiKey?: string;
};

export const getStartupMessage = async (): Promise<StartupMessage> => {
    const { data } = await axios.get("/startup");
    return {
        user: data.user,
        registrars: data.registrars,
        apiServices: data.api_services,
        scribensApiKey: data.scriben_api_key,
    };
};
